function giftWrappingMutation() {
  
  // The variant ID of the Gift Wrapping product
  const giftWrappingId = window.lapyae_gift_wrapping_id;

  // The current cart state JSON from the liquidAjaxCart.cart property
  const cart = window.liquidAjaxCart.cart;

  // If the cart is empty -- do nothing, stop the function
  if (cart.item_count === 0) {
    return;
  }

  // If the cart is not empty, let's find out if the Mug product is in the cart
  const giftWrappingItem = cart.items.find(item => {
    return item.variant_id === giftWrappingId;
  });

  // If the cart is not empty, let's find out if the Mug product is in the cart
  const otherProducts = cart.items.find(item => {
    return item.variant_id != giftWrappingId;
  });
  
  // If the gift wrapping product is not in the cart -- do nothing
  if (!giftWrappingItem) {
    return;
  }

  // If the gift wrapping is the only product in the basket, remove it
  if ( ! otherProducts ) {
    return {
      requests: [
        {
          type: "change", // remove the first item from the cart
          body: {
            line: 1,
            quantity: 0
          }
        }
      ]
    }
  }
}

// Let Liquid Ajax Cart know about the mutation functions
window.liquidAjaxCart.conf('mutations', [
  giftWrappingMutation
]);